// src/hooks/useUserClaims.ts
import { useAuthStore } from '../stores/authStore'

/**
 * Custom hook for accessing user claims and role-based permissions
 */
export function useUserClaims() {
  const { claims, user } = useAuthStore()

  return {
    claims,
    user,
    isAdmin: claims?.role === 'admin',
    isSuperAdmin: claims?.role === 'super_admin',
    organizationId: claims?.organization_id,
    hasRole: (role: string) => claims?.role === role,
    canAccessAllOrgs: claims?.role === 'super_admin',

    // Permission helpers
    canManageUsers: claims?.role === 'admin' || claims?.role === 'super_admin',
    canManageOrganizations: claims?.role === 'super_admin',
  }
}
